import React from "react";
import { ViewMore } from "../../pages/InvoiceReceipt";

const ViewMoreContainer = ({closeModal}) => {
    
    return (
        <ViewMore closeModal={closeModal}/>
    )
}
export default ViewMoreContainer;